/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, { teacher_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teacher/${teacher_id}/working-time?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { teacher_id, working_time_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `teacher/${teacher_id}/working-time/${working_time_id}?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWorkingTime({ commit }, { teacher_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`teacher/${teacher_id}/working-time`, payload)
        .then((response) => {
          commit("ADD_WORKING_TIME", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  registerWorkingTime({ commit }, { teacher_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`teacher/${teacher_id}/register-working-time`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWorkingTime({ commit }, { teacher_id, working_time_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`teacher/${teacher_id}/working-time/${working_time_id}?`, payload)
        .then((response) => {
          commit("UPDATE_WORKING_TIME", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteWorkingTimeItem({ commit }, { teacher_id, working_time_id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`teacher/${teacher_id}/working-time/${working_time_id}`)
        .then((response) => {
          commit("DELETE_WORKING_TIME_ITEM", working_time_id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getTeacherSelfStudyCourse({ commit }, { teacher_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `teacher/${teacher_id}/teacher-self-study-course?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_SELF_STUDY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
